export enum REQUEST_STATUSES {
  PENDING = "pending",
  LOADING = "request",
  SUCCESS = "fulfilled",
  ERROR = "rejected",
}
